<template>
    <b-container fluid class="p-0">
        <situacao-licitacao :idLicitacao="disp.IdLicitacao" />
        <b-card class="mx-3" no-body>
            <template #header>
                <h6 class="mb-0 text-center">
                    <span class="titulo-sagres font-weight-bold">{{ tituloPagina }}</span>
                    <btn-voltar />
                </h6>
            </template>
            <b-tabs v-model="abaAtiva" card>
                <b-tab>
                    <template #title>
                        <font-awesome-icon icon="pencil" class="mr-1 text-info" />
                        Dados iniciais
                    </template>
                    <aba-editar-dados-iniciais-di v-if="showForm && abaAtiva === 0" @atualizarLicitacao="atualizarLicitacao"
                        :lic="disp" />
                </b-tab>
                <b-tab v-if="isEdit" lazy>
                    <template #title>
                        <font-awesome-icon icon="address-card" class="mr-1 text-success" />
                        Credores
                    </template>
                    <aba-editar-participantes :lic="disp" mododi />
                </b-tab>
                <b-tab v-if="isEdit" lazy>
                    <template #title>
                        <font-awesome-icon icon="shopping-cart" class="mr-1 text-primary" />
                        Itens
                    </template>
                    <aba-editar-itens-di :lic="disp" />
                </b-tab>
                <b-tab v-if="isEdit" class="p-0" lazy>
                    <template #title>
                        <font-awesome-icon icon="hourglass-end" class="mr-1 text-secondary" />
                        Histórico
                    </template>
                    <detalhes-historico :idLicitacao="disp.IdLicitacao" />
                </b-tab>
            </b-tabs>
        </b-card>
    </b-container>
</template>

<script lang="ts">
import DetalhesHistorico from '@/components/licitacoes/ldi/DetalhesHistorico.vue'
import SituacaoLicitacao from '@/components/licitacoes/ldi/SituacaoLicitacao.vue'
import AbaEditarDadosIniciaisDi from '@/components/licitacoes/ldi/editar-ldi/AbaEditarDadosIniciaisDi.vue'
import AbaEditarItensDi from '@/components/licitacoes/ldi/editar-ldi/AbaEditarItensDi.vue'
import AbaEditarParticipantes from '@/components/licitacoes/ldi/editar-ldi/AbaEditarParticipantes.vue'
import BtnVoltar from '@/components/shared/BtnVoltar.vue'
import ldiService from '@/services/licitacoes/ldiService'
import { store } from "@/store"
import { Licitacao } from '@/types/licitacoes/ldi/licitacao'
import { UtilsTS } from '@/utilsts'
import { mixins } from 'vue-class-component'
import { Component, Vue } from 'vue-property-decorator'

const CompProps = Vue.extend({
    name: 'EditarDispensaInex',
    components: {
        AbaEditarDadosIniciaisDi, AbaEditarItensDi, AbaEditarParticipantes,
        BtnVoltar, DetalhesHistorico, SituacaoLicitacao
    },
    props: {
        idLicitacao: {
            type: String,
            default: ''
        }
    },
})

@Component
export default class EditarDispensaInex extends mixins(UtilsTS, CompProps) {
    disp: Licitacao = new Licitacao()
    isEdit = false
    abaAtiva = 0 // qual aba está ativa no momento
    showForm = false

    get tituloPagina(): string {
        return `${this.isEdit ? 'Editar' : 'Criar'} Dispensa/Inexigibilidade ${this.isEdit ? this.disp.NumeroAnoLicitacao : ''}`
    }

    get mostrarBtnSave(): boolean {
        return this.abaAtiva === 0
    }

    async created(): Promise<void> {
        try {
            store.blockScreen = true
            //console.log('created', this.idLicitacao, this.idLicitacao.length > 0)
            if (this.idLicitacao.length > 0) {
                this.isEdit = true
                this.disp = await ldiService.buscarDadosGerais(this.idLicitacao)
            }
        }
        catch (e: unknown) {
            console.error('Erro ao abrir a edição de licitações', e)
        } finally {
            this.showForm = true
            store.blockScreen = false
        }
    }

    /**
     * Vamos tentar centralizar aqui as mudanças em flags de controle e no objeto principal 'licitacao'
     * @param li nova instância de licitação, recém recebida da API
     */
    async atualizarLicitacao(li?: Licitacao): Promise<void> {
        store.blockScreen = true
        try {
            if (!li) li = await ldiService.buscarDadosGerais(this.idLicitacao ?? this.disp.IdLicitacao)
            this.disp = Object.assign(new Licitacao(), li)
            if (li.IdLicitacao > 0) this.isEdit = true
        } finally {
            store.blockScreen = false
        }
    }
}
</script>

<style></style>